<template>
  <v-theme-provider dark>
    <base-section
      id="social"
      class="secondary text-center"
      space="10"
    >
      <br></br>
      <base-section-heading
        color="transparent"
        title="Digital Agency"
        class="pt-4"
      >
        Looking for a 3D asset to add to your next production? Discover our collection below and contact us for further information regarding licensing a 3D asset today.
      </base-section-heading>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionNews',

    provide: {
      heading: { align: 'center' },
    },
  }
</script>
